"use client";

import { useStickToBottomContext } from "use-stick-to-bottom";
import { ConversationScrollButton } from "@/components/ai-elements/conversation";

// Its own row under the messages rather than floating over them: floating, it
// covered whatever card or action row sat at the bottom of the view.
export function ScrollToLatest() {
  const { isAtBottom } = useStickToBottomContext();
  if (isAtBottom) return null;
  return (
    <div className="flex shrink-0 justify-center bg-background py-1">
      <ConversationScrollButton
        aria-label="Scroll to latest"
        className="static size-7 translate-x-0"
      />
    </div>
  );
}
